import "./merchantConfigView.js";
import "../merchantConfigShared.less";



// WEBPACK FOOTER //
// ./src/pages/merchantConfig/merchantConfigView/index.js